var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dt",
    {
      staticClass:
        "header column-12 tablet:column-3 laptop:column-2 margin-top-xs tablet:margin-top-0 padding-sm muted",
    },
    [
      _c(
        "span",
        {
          attrs: {
            "aria-label": _vm.featureDescription,
            "data-balloon-pos": "right",
          },
        },
        [
          _c("font-awesome-icon", {
            staticClass: "decorative margin-right-2xs",
            attrs: {
              icon: _vm.$v6.solid[_vm.featureIcon],
              size: "lg",
              "fixed-width": "",
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                "text-decoration": "underline",
                cursor: "pointer",
              },
            },
            [_vm._v(_vm._s(_vm.featureName))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }